module.exports = __webpack_public_path__ + "img/app-yms.e7b5df4f.webp";